module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@3x-8273ba695692615c22231bc164067044.png";